var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon mail-icon",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0a2 2 0 012 2v10a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h16zm-5.525 7.998l-1.8 1.65a.998.998 0 01-1.25.08l-.1-.08-1.8-1.65L2.647 12.5h14.705l-4.877-4.502zM18.5 2.474L13.585 6.98l4.915 4.538V2.474zm-17 .001v9.042L6.414 6.98 1.5 2.475zM17.344 1.5H2.655L10 8.233 17.344 1.5z",
    fillRule: "evenodd"
  })));
}

export default SvgMailIconSv;